import { render } from "./AboutReverse.vue?vue&type=template&id=2d815cbc&scoped=true"
import script from "./AboutReverse.vue?vue&type=script&lang=js"
export * from "./AboutReverse.vue?vue&type=script&lang=js"

import "./AboutReverse.vue?vue&type=style&index=0&id=2d815cbc&scoped=true&lang=css"

import exportComponent from "/Users/czh/Desktop/czh/yog_website/lada/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d815cbc"]])

export default __exports__